module.exports = __webpack_public_path__ + "static/sara-mangialavori-54d75532e16a71f5f5d2834a06c7a133.jpg";